import { inject, Injectable } from '@angular/core';
import { setLicenseKey } from '@mescius/wijmo';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { NavigationActions } from '@src/suite/common/store/navigation/actions/navigation.actions';
import { calculatePropComparators, calculateViewStateFilters } from '@src/suite/common/utils/global-tables.utils';
import { exhaustMap, map } from 'rxjs';

import { GlobalTablesActions } from './global-tables.actions';
import {
    selectAllGroups,
    selectGroups,
    selectPlaybookTeams,
    selectPSTGroupId,
    selectSecurityPrivileges,
    selectServers,
    selectWijmoApiKey,
    selectWireCategories,
    selectWireProviders,
} from './global-tables.selectors';

@Injectable()
export class GlobalTablesEffects {
    actions$ = inject(Actions);
    store = inject(Store);

    // TODO: We need to refactor global tables/fields getting and initializing
    globalTablesService = inject(GlobalTablesService);

    processGlobalTables$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GlobalTablesActions.processGlobalFields),
            concatLatestFrom(() => [
                this.store.select(selectI18N),
                this.store.select(selectSecurityPrivileges),
                this.store.select(selectPSTGroupId),
                this.store.select(selectServers),
                this.store.select(selectGroups),
                this.store.select(selectAllGroups),
                this.store.select(selectPlaybookTeams),
                this.store.select(selectWireCategories),
                this.store.select(selectWireProviders),
            ]),
            map(([action, i18n, securityPrivileges, pstGroup, servers, groups, allGroups, playbookTeams, wireCategories, wireProviders]) => {
                const groupSort = calculatePropComparators(action.fieldsDefDict, i18n);
                const viewStateFilters = calculateViewStateFilters(
                    action.fieldsDef,
                    action.fieldsDefDict,
                    i18n,
                    securityPrivileges,
                    pstGroup,
                    servers,
                    groups,
                    allGroups,
                    playbookTeams,
                    wireProviders,
                    wireCategories
                );
                return GlobalTablesActions.setGlobalFields({ fieldsDefDict: action.fieldsDefDict, fieldsDef: action.fieldsDef, groupSortDefs: groupSort, viewStateFiltersDefs: viewStateFilters });
            })
        );
    });

    setWijmoLicenseKey$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GlobalTablesActions.setGlobalTables),
            exhaustMap(() => {
                const wijmoApiKey = this.store.selectSignal(selectWijmoApiKey)();
                setLicenseKey(wijmoApiKey);
                return [
                    NavigationActions.preInitializeNavigation(),
                    GlobalTablesActions.processGlobalFields({ fieldsDefDict: this.globalTablesService.FieldDefsDict, fieldsDef: this.globalTablesService.FieldDefs }),
                ];
            })
        );
    });
}
